export default function PageHeader({ overline, title, description, actions }) {
  // RU-UIMOBILE UM-12: below sm the actions stack under the title and wrap, so they never push the page
  // wider than the phone; from sm the layout is unchanged.
  return (
    <div className="px-4 py-5 sm:px-8 sm:py-7 border-b border-[var(--border)] flex flex-col sm:flex-row items-start sm:justify-between gap-4 sm:gap-6 hero-overlay">
      <div>
        <div className="overline">{overline}</div>
        <h1 className="font-display text-4xl sm:text-5xl mt-1 tracking-tight">{title}</h1>
        {description && (
          <p className="txt-secondary mt-2 max-w-2xl text-sm">{description}</p>
        )}
      </div>
      {actions && <div data-testid="page-header-actions" className="flex flex-wrap items-center gap-2 max-w-full sm:shrink-0">{actions}</div>}
    </div>
  );
}
